export default "__VITE_ASSET__85Z51Xjh__"